import React from "react";
import { ThunderboltOutlined, CrownFilled, WarningOutlined } from "@ant-design/icons";
import GameDetails from "./GameDetails";

const ItiGameSequential: React.FC = () => (
    <GameDetails
        game="itiSequential"
        tagColor="blue"
        fallbackInstructionIcon={<WarningOutlined style={{ color: "#ff4d4f" }} />}
        instructionIcons={[
            <ThunderboltOutlined key="first" style={{ color: "#ffec3d" }} />,
            <CrownFilled key="second" style={{ color: "#faad14" }} />,
            <WarningOutlined key="third" style={{ color: "#ff4d4f" }} />,
        ]}
    />
);

export default ItiGameSequential;
